export default __webpack_public_path__ + "static/media/arrow_top_icon--gray.6561ff3f.svg";